import { createSelector } from 'reselect';
import { getFileInfoState } from './getFileInfoState';
import { FileUploadStatus } from '../enums';
import { FileHelperService } from '../services';
export const getUploadRetryableFailedFiles = createSelector(getFileInfoState, (state) => state.allIds
    .map(id => state.byId[id])
    .filter(fileInfo => !FileHelperService.getIsUploadValidationError(fileInfo.uploadError) &&
    fileInfo.uploadStatus === FileUploadStatus.FAILED));
//# sourceMappingURL=getUploadRetryableFailedFiles.js.map